
export default function WhyChooseUs() {
  const features = [
    {
      icon: 'ri-bar-chart-line',
      title: '100% Transparent Reporting',
      description: 'Complete visibility into your campaign performance with detailed analytics and regular reports.'
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'ROI-Based Strategies',
      description: 'Every strategy is designed to maximize your return on investment and drive profitable growth.'
    },
    {
      icon: 'ri-team-line',
      title: 'Expert Team in Every Domain',
      description: 'Specialists in Facebook Ads, Google Ads, SEO, and performance marketing working for your success.'
    },
    {
      icon: 'ri-trophy-line',
      title: 'Proven Track Record',
      description: 'Successfully scaled hundreds of e-commerce brands with measurable results and growth.'
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Why Choose Us
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            We combine expertise, transparency, and results to deliver exceptional marketing solutions
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="text-center">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className={`${feature.icon} text-2xl text-blue-600`}></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-gray-600">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
